import * as types from './types';

export const getTheme = (data) => {
  return {
    type: types.GET_THEME,
    payload: { data },
  };
};

export const setTheme = (data) => {
  return {
    type: types.SET_THEME,
    payload: { data },
  };
};

export const setPhotoDispute = (data) => {
  return {
    type: types.SET_PHOTO_DISPUTE,
    payload: { data },
  };
};

export const setCaptureFlow = (
  flow,
  flowData = [],
  flowScreen = [],
  isSkippable = false
) => {
  return {
    type: types.SET_CAPTURE_FLOW,
    payload: { flow, flowData, flowScreen, isSkippable },
  };
};

export const setCaptureSkip = (data) => {
  return {
    type: types.SET_CAPTURE_SKIP,
    payload: data,
  };
};

export const resetTheme = () => ({
  type: types.CLEAR_THEME,
});

export const getFlow = () => ({
  type: types.GET_FLOW,
});

export const getUrlParams = (data) => ({
  type: types.QUERY_URL,
  payload: { data },
});

export const setUserCustomTheme = (payload) => ({
  type: types.USER_CUSTOM,
  payload,
});

export const setCurrentStage = (stage) => ({
  type: types.SET_CURRENT_STAGE,
  payload: stage,
});
